import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'

import { RootState } from '@/types/store'

import { multiUser } from './multi-user'
import { receipt } from './receipt'
import { user } from './user'
import { monitor } from './monitor'
import { chainStore } from './chain-store'
import { recommend } from './recommend'
import { place } from './place'
import { shop } from './shop'
import { item } from './item'
import { matched } from './matched'
import { brandSku } from './brand-sku'
import { log } from './log'
import { qlog } from './qlog'
import { slog } from './slog'
import { contributer } from './contributer'
import { notice } from './notice'
import { questionnaire } from './questionnaire'
import { questionnaireAnswer } from './questionnaire-answer'
import { channel } from './channel'
import { category } from './category'
import { specialOffer } from './special-offer'
import { specialOfferReceipt } from './special-offer-receipt'

Vue.use(Vuex)

const store: StoreOptions<RootState> = {
  state: {
    version: '1.0.0',
  },
  modules: {
    receipt,
    user,
    monitor,
    multiUser,
    chainStore,
    recommend,
    place,
    shop,
    item,
    matched,
    brandSku,
    log,
    qlog,
    slog,
    contributer,
    notice,
    questionnaire,
    questionnaireAnswer,
    channel,
    category,
    specialOffer,
    specialOfferReceipt,
  },
}

export default new Vuex.Store<RootState>(store)
